import styled, { css } from 'styled-components';
import { Breakpoints } from '../../styled/constants';
import { animation } from '../../styled/placeholders.styled';

export const SearchPlaceholder = styled.div`
  ${animation};
  height: 50px;
  width: 100%;
  border-radius: 14px;

  @media screen and (min-width: ${Breakpoints.desktop}px) {
    max-width: 340px;
  }
`;

export const SpinnerWrapper = styled.div`
  margin: 150px auto;
  width: 100%;
`;

export const Spinner = styled.span`
  display: block;
  margin: 0 auto;
  width: 30px;
  height: 30px;
  animation: rotation 2s infinite linear;
  background-image: url('/static/images/icon-spinner.svg');
`;

export const fallbackStyles = css`
  padding: 20px 0 15vh;

  @media screen and (min-width: ${Breakpoints.tablet}px) {
    padding: 10vh 15px 15vh;

    img {
      width: 317px;
      height: 230px;
    }
  }
`;

export const ResidenceControlsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  width: 100%;

  @media screen and (min-width: ${Breakpoints.desktop}px) {
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    gap: 20px;
    width: auto;
    flex: 1;
  }
`;
